/**
 * Created by amoghpalnitkar on 7/29/17.
 */

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (err) {
    //log this
  }
};

export const getCookie = cname => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const storeUser = data => {
  try {
    const serializedState = JSON.stringify(data);
    localStorage.setItem("USER_DETAILS", serializedState);
  } catch (err) {
    //log this
  }
};

export const getUser = () => {
  try {
    const serializedState = localStorage.getItem("USER_DETAILS");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const storeIdToken = idtoken => {
  try {
    // const serializedState = JSON.stringify(idtoken);
    localStorage.setItem("ID_TOKEN", idtoken);
  } catch (err) {
    //log this
  }
};

export const getIdToken = () => {
  try {
    const serializedState = localStorage.getItem("ID_TOKEN");
    if (serializedState === null) {
      return undefined;
    }
    return serializedState;
  } catch (err) {
    return undefined;
  }
};

export const storeAccessToken = access => {
  try {
    // const serializedState = JSON.stringify(access);
    localStorage.setItem("ACCESS_TOKEN", access);
  } catch (err) {
    //log this
  }
};

export const getAccessToken = () => {
  try {
    const serializedState = localStorage.getItem("ACCESS_TOKEN");
    if (serializedState === null) {
      return undefined;
    }
    return serializedState;
  } catch (err) {
    return undefined;
  }
};

export const storeStatesMaster = access => {
  try {
    const serializedState = JSON.stringify(access);
    localStorage.setItem("STATES_MASTER", serializedState);
  } catch (err) {
    //log this
  }
};

export const getStatesMaster = () => {
  try {
    const serializedState = localStorage.getItem("STATES_MASTER");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};


export const storeServiceTypesMaster = access => {
  try {
    const serializedState = JSON.stringify(access);
    localStorage.setItem("SERVICE_TYPES_MASTER", serializedState);
  } catch (err) {
    //log this
  }
};

export const getServiceTypesMaster = () => {
  try {
    const serializedState = localStorage.getItem("SERVICE_TYPES_MASTER");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const storeESPUser = data => {
  try {
    const serializedState = JSON.stringify(data);
    localStorage.setItem("ESP_USER_DETAILS", serializedState);
  } catch (err) {
    //log this
  }
};

export const getESPUser = () => {
  try {
    const serializedState = localStorage.getItem("ESP_USER_DETAILS");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const storeESPSendSMSDetails = data => {
  try {
    const serializedState = JSON.stringify(data);
    localStorage.setItem("ESP_SEND_SMS_DETAILS", serializedState);
  } catch (err) {
    //log this
  }
};

export const getESPSendSMSDetails = () => {
  try {
    const serializedState = localStorage.getItem("ESP_SEND_SMS_DETAILS");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const storeLPMAdminColumns = data => {
  try {
    const serializedState = JSON.stringify(data);
    localStorage.setItem("LPM_ADMIN_COLUMNS", serializedState);
  } catch (err) {
    //log this
  }
};

export const getLPMAdminColumns = () => {
  try {
    const serializedState = localStorage.getItem("LPM_ADMIN_COLUMNS");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const storeSPMAdminColumns = data => {
  try {
    const serializedState = JSON.stringify(data);
    localStorage.setItem("SPM_ADMIN_COLUMNS", serializedState);
  } catch (err) {
    //log this
  }
};

export const getSPMAdminColumns = () => {
  try {
    const serializedState = localStorage.getItem("SPM_ADMIN_COLUMNS");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};


export const storeToolsTemplateColumns = data => {
  try {
    const serializedState = JSON.stringify(data);
    localStorage.setItem("TOOL_TEMPLATE_COLUMNS", serializedState);
  } catch (err) {
    //log this
  }
};

export const getToolsTemplateColumns = () => {
  try {
    const serializedState = localStorage.getItem("TOOL_TEMPLATE_COLUMNS");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};